import { browserHistory } from 'react-router';
import { fetchListIds } from '../FindDuplicateContacts/fetchFilteredIds';
import { writeMailMergeSelection } from '../../utils';

/** Mirrors MailMergeService::MAX_CONTACTS — refused here so the user is told why. */
export const MAIL_MERGE_MAX_CONTACTS = 5000;

/**
 * Opens the mail merge for every row the Vendors or Agents list currently
 * matches — every page of it, not just the fifty on screen. The ids are read
 * here because the filters live in the list's Arc query, which the server
 * never sees; it looks the people up again from the ids.
 *
 * Ticked rows win over the filter, as on the Properties list: a user who
 * ticked six agents means those six. Pass them as `selectedIds`.
 *
 * @param {{audience: string, noun: string, queryName: string, filterKey: string, query: object, selectedIds?: string[]}} list
 * @returns {Promise<void>}  rejects with a message the list can show
 */
export default function startContactMailMerge({ audience, noun, queryName, filterKey, query, selectedIds }) {
    const tooMany = `A mail merge reaches up to ${MAIL_MERGE_MAX_CONTACTS.toLocaleString()} ${noun}s, and this list has `
        + 'more than that. Narrow the filter, or tick the rows you want, and press Mail Merge again.';

    const chosen = selectedIds && selectedIds.length
        ? Promise.resolve(selectedIds)
        : fetchListIds(queryName, filterKey, query, { limit: MAIL_MERGE_MAX_CONTACTS + 1, tooMany });

    return chosen.then((ids) => {
        if (!ids.length) throw new Error(`This list has no ${noun}s to mail merge.`);
        if (ids.length > MAIL_MERGE_MAX_CONTACTS) {
            throw new Error(`A mail merge reaches up to ${MAIL_MERGE_MAX_CONTACTS.toLocaleString()} ${noun}s, and `
                + `${ids.length.toLocaleString()} are ticked. Clear some and press Mail Merge again.`);
        }

        writeMailMergeSelection({
            audience,
            contactIds: ids.map(String),
            query,
            capturedAt: new Date().toISOString(),
        });

        browserHistory.push('/mail-merge');
    });
}
